/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacTaurus = createLucideIcon("zodiac-taurus", [
  ["circle", { cx: "12", cy: "15", r: "6", key: "lhqcmb" }],
  ["path", { d: "M18 3A6 6 0 0 1 6 3", key: "1p399e" }]
]);

export { ZodiacTaurus as default };
//# sourceMappingURL=zodiac-taurus.js.map
